<div class="access-denied">
  <div class="access-denied__wrapper">
    <h2>
      {{ 'ERROR.401_PAGE.TITLE' | translate }}
    </h2>
    <p class="access-denied__message">
        {{ 'ERROR.401_PAGE.MESSAGE' | translate }}
    </p>
    <button mm-button color="primary" size="large"  (click)="navigateToCustomerSupport()">
      {{ 'ERROR.401_PAGE.BUTTON_LABEL' | translate }}
    </button>
  </div>
</div>
